const state = {}

const getters = {
  getGames: (state, getters, rootState, rootGetters) => (rootGetters["Game/pgGamesMap"] || {}),
  getGameByKey: (state, getters) => key => (getters.getGames[key] || null ),
  instaproGames: (state, getters, rootState, rootGetters) => (rootGetters["Game/instaproGames"] || []).reduce(
    (result, game) => ({ ...result, [game.name]: game }),
    {}
  ),
  availableInstaproGames: (state, getters) => {
    // games here are available in proguides
    const games = []
    try {
      if (getters.getGames) {
        Object.values(getters.getGames).forEach(game => {
          if (game.status === "available" && getters.instaproGames[game.key]) {
            games.push(getters.instaproGames[game.key])
          }
        })
      }
    } catch (error) {}
    return games
  },
}

const mutations = {}

const actions = {
  async loadGames ({ dispatch }) {
    await dispatch("Game/fetchPgGames", null, { root: true })
  },
  async loadInstaproGames ({ dispatch }) {
    await dispatch("Game/fetchInstaproGames", null, { root: true })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/games.js